import React from "react";
import { Link } from "react-router-dom";

export default function MobileFooterMenu() {
  return (
    <footer style={styles.footer}>
      <Link to="/admin/dashboard/orders" style={styles.iconLink}>
        <span style={styles.iconArea}>🛒</span>
        <span style={styles.linkLabel}>Ordini</span>
      </Link>
      <Link to="/admin/dashboard/kpi" style={styles.iconLink}>
        <span style={styles.iconArea}>📊</span>
        <span style={styles.linkLabel}>KPI</span>
      </Link>
      <Link to="/admin/dashboard/piatti" style={styles.iconLink}>
        <span style={styles.iconArea}>🍽</span>
        <span style={styles.linkLabel}>Piatti</span>
      </Link>
      <Link to="/admin/dashboard/ai" style={styles.iconLink}>
        <span style={styles.iconArea}>⚡</span>
        <span style={styles.linkLabel}>AI</span>
      </Link>
    </footer>
  );
}

// Palette coerente con i tuoi design
const palette = {
  primaryStart: "#FF8C00",
  primaryEnd: "#FF6600",
  textLight: "#FFF",
};

const styles = {
  footer: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    // Altezza leggermente maggiore per area “tappabile”
    height: "70px",
    // Sfondo con gradiente
    background: `linear-gradient(180deg, ${palette.primaryStart} 0%, ${palette.primaryEnd} 100%)`,
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    color: palette.textLight,
    // Ombra in alto
    boxShadow: "0 -2px 5px rgba(0,0,0,0.2)",
    // Bordo arrotondato agli angoli superiori
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    // Spazio extra per notch iOS, se serve
    paddingBottom: "calc(env(safe-area-inset-bottom, 0))",
    zIndex: 999,
  },

  iconLink: {
    // Layout verticale (icona + testo)
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textDecoration: "none",
    color: palette.textLight,
    fontSize: "13px",
    // Effetto “cliccabile”
    transition: "transform 0.2s",
    width: "60px",
    textAlign: "center",
    // Se vuoi un piccolo effetto su hover / active (desktop e simulato)
    ':hover': {
      transform: "scale(1.1)",
    },
  },

  iconArea: {
    fontSize: "22px",
    lineHeight: 1.2,
    marginBottom: "4px",
  },

  linkLabel: {
    fontSize: "12px",
    lineHeight: "14px",
    fontWeight: "bold",
  },
};
